import React from 'react'

interface Props {
  resource: string | any
  className?: string
}

enum nodeType {
  PAGE = 'Page',
  POST = 'Post',
  WHITEPAPER = 'Whitepaper',
  WEBINAR = 'Webinar',
  CASESTUDY = 'Casestudy',
  TOOLKIT = 'Tool',
  INFOGRAPHIC = 'Infographic',
}

const ResourceType: React.FC<Props> = ({ resource, className }): JSX.Element => {
  let resourceName

  if (resource === nodeType.POST) {
    resourceName = 'Blog'
  } else if (resource === nodeType.WHITEPAPER) {
    resourceName = 'White Paper'
  } else if (resource === nodeType.CASESTUDY) {
    resourceName = 'Case Study'
  } else if (resource === nodeType.TOOLKIT) {
    resourceName = 'Tool Kit'
  } else {
    resourceName = resource
  }

  return <span className={className}>{resourceName}</span>
}

export default ResourceType
